export default "__VITE_ASSET__DMl733dh__"